import { Grid } from '@strapi/design-system/Grid';
import { FC, useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useOutletContext } from 'react-router-dom';
import { getChangedFields } from '../../../helpers/getChangedFields';
import { useAppSelector } from '../../../store/hooks';
import { StepContext } from '../../../types';
import { ContactPerson } from '../ContactPerson';
import { Step } from './step';

export const Step4: FC = () => {
  const { prev, save, submit } = useOutletContext<StepContext>();
  const { contactPerson } = useAppSelector(state => state.offer.form);

  const {
    register,
    control,
    handleSubmit,
    getValues,
    setValue,
    reset,
    trigger,
    formState: { errors, isDirty, dirtyFields }
  } = useForm({
    reValidateMode: 'onBlur',
    defaultValues: {
      contactPerson
    }
  });

  const cleanCallback = useCallback(() => {
    reset({
      contactPerson: {
        name: '',
        position: '',
        email: '',
        phone: '',
        additional: '',
        image: null
      }
    }, { keepDirty: true });
  }, []);

  const resetCallback = useCallback(() => {
    reset({ contactPerson });
  }, []);

  const onSubmit = handleSubmit((fields) => {
    submit(getChangedFields(fields, dirtyFields));
  });

  const saveCallback = () => {
    trigger().then((isValid) => {
      if (isValid) save(getChangedFields(getValues(), dirtyFields));
    });
  };

  useEffect(() => {
    reset({ contactPerson })
  }, [contactPerson]);

  return <Step
    title="Ansprechpartner"
    onSubmit={onSubmit}
    prevCallback={prev}
    cleanCallback={cleanCallback}
    resetCallback={resetCallback}
    isDirty={isDirty}>
    <input id="save" hidden onClick={saveCallback} />
    <Grid gap={5}>
      <ContactPerson register={register} control={control} errors={errors} setValue={setValue} />
    </Grid>
  </Step>;
};